import { CardOrderBase } from "./CardOrderBase";

export class CardOrderBusinessCard extends CardOrderBase {

    KortEjerNavn: string = "";
    KortEjerAdresse: string = "";
    PostAdresseNavn: string = "";
    PostAdresseVejOgNr: string = "";
    PostAdresseStedNavn: string = "";
    PostAdressePostNr: string = "";
    PostAdressePostDistrikt: string = "";
    GyldighedStartDato: Date | null = null;
    KortNrTidligereKort: string = "";
    UdloebsDato: Date | null = null;
    UdstedendeMyndighed: string = "";
    CvrNr: string = "";
    KoereKortNationalitet: string = "";
    KoerekortUdstedendeMyndighed: string = "";
    Antal: string = "";
    AnsvarligIndehaver: string = "";
    Malfunctioning: boolean = false;
    IsAndenGeneration: string = "";

    //These values are always null, based on looking at older orders.
    KortBrugerFornavn: string | null = null
    FoedselsDato: Date | null = null;//Example: 2022-01-22T00:00:00
    MekanikerPostNr: string | null = null;
    StamkortReferenceNr: string | null = null;
}